import { Box, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "@/app/store";
import {
  selectCognitoConfig,
  selectCredentialLoginDisabled,
} from "@/features/app-config/model/tenantConfigurationSlice";
import { resolveAuthRealm } from "@/shared/auth/authRealm";
import { useAuth } from "@/shared/auth/useAuth";
import { isPostLogoutSession } from "@/shared/auth/postLogoutSession";
import { startCognitoLogin } from "@/shared/auth/startCognitoLogin";

export function RequireAuth() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const cognitoConfig = useAppSelector(selectCognitoConfig);
  const credentialLoginDisabled = useAppSelector(selectCredentialLoginDisabled);
  const authRealm = resolveAuthRealm();
  const postLogout = isPostLogoutSession();

  useEffect(() => {
    if (isAuthenticated || !cognitoConfig) return;

    void startCognitoLogin({
      cognitoConfig,
      returnPath: location.pathname,
      // Ask Cognito for its sign-in page after a logout, and on tenants that sign in through an
      // identity provider only — there, Cognito would otherwise forward straight through and the
      // user would never see a sign-in screen.
      forceLogin: postLogout || credentialLoginDisabled,
      realm: authRealm,
    });
  }, [
    isAuthenticated,
    cognitoConfig,
    location.pathname,
    postLogout,
    credentialLoginDisabled,
    authRealm,
  ]);

  if (!isAuthenticated) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        aria-busy
      >
        <CircularProgress />
      </Box>
    );
  }

  return <Outlet />;
}
